export const sessionId = "sessionid";
export const paymentReference = "payment_reference";
export const isSmartId = "isSmartId";
export const userEmailForVerification = "userEmailForVerification";
export const wasPaymentStatusShown = "wasPaymentStatusShown";
